import http from './api'
import { Cuisine } from '../types/restaurant'

export interface CuisineDish {
  id: string
  name: string
  region?: string
  ingredients?: { id: string; name: string }[]
}

export interface CuisineCategoryWithDishes {
  id: string
  name: string
  dishes: CuisineDish[]
}

export interface CuisineIngredient {
  id: string
  name: string
}

class CuisineService {
  async getCuisines(): Promise<Cuisine[]> {
    const response = await http.get<Cuisine[]>('/cuisines')
    return response.data
  }

  async getCuisine(id: string): Promise<Cuisine | null> {
    const response = await http.get<Cuisine>(`/cuisines/${id}`)
    return response.data
  }

  async getDishesByCuisine(cuisineId: string): Promise<CuisineCategoryWithDishes[]> {
    const response = await http.get<CuisineCategoryWithDishes[]>(`/cuisines/${cuisineId}/dishes`)
    return response.data
  }

  async getIngredientsByCuisine(cuisineId: string): Promise<CuisineIngredient[]> {
    const response = await http.get<CuisineIngredient[]>(`/cuisines/${cuisineId}/ingredients`)
    return response.data
  }
}

const cuisineService = new CuisineService()
export default cuisineService
